import styled from 'styled-components';

export const Line = styled.div`
  border-style: solid;
  border-width: 1px 0px 0px 0px;
  max-width: inherit;
  border-color: ${(props) => props.theme.colors.lightGray};
  margin: 20px 0px 20px 0px;

  @media screen and (max-width: 960px) {
    width: 320px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (max-width: 960px) {
    align-items: center;
  }

  .container {
    @media screen and (max-width: 960px) {
      display: flex;
      width: 350px;
      flex-direction: column;
      align-items: center;
    }
  }
  .call {
    color: ${(props) => props.theme.colors.white};
    text-decoration: none;
  }

  .phoneDiv {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    color: ${(props) => props.theme.colors.black};

    .phone {
      margin-top: 8px;
      font-size: 20px;
      font-weight: bold;
      color: ${(props) => props.theme.colors.black};
    }
  }

  .buttonDiv {
    display: none;
    width: 320px;
    @media screen and (max-width: 960px) {
      display: grid;
      margin-top: 32px;
    }
  }

  .attendanceDiv {
    display: flex;
    flex-direction: column;
    width: inherit;
    font-size: 14px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.gray};
    justify-content: flex-start;
    .fix {
      margin-bottom: 4px;
    }

    .attendance {
      margin-top: 4px;
      font-size: 16px;

      font-weight: normal;
      color: ${(props) => props.theme.colors.gray};
    }
  }
`;
